export default {"src":"/_next/static/media/cantaloupe.1f883614.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};